function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFidelity = function SvgFidelity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C9 40 0 31 0 20S9 0 20 0s20 9 20 20-9 20-20 20z",
    style: {
      fill: "#128741"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 3.5C10.9 3.5 3.5 10.9 3.5 20S10.9 36.5 20 36.5 36.5 29.1 36.5 20 29.1 3.5 20 3.5zM29.9 32l-.4-.7-3.7-6.3 5.8 3.2s.1 0 0-.1L24 21.6l9.8 1.5-.1-.1-9.2-3.2 9.7-2.3v-.1l-9.8.7 7.1-5.3.7-.6s-.1-.1-.1 0l-7.4 3.7-1.3.7 4.8-8.4s0-.1 0 0L22 15.6l1-9.7h-.1L20 15.2l-.8-2.9-1.7-6.8h-.1v.8l.7 9.1-5.9-7.7 4.5 8.6-8.5-4.6 6.8 5.6.8.7L6 17v.1l9.3 2.7L6 22.5v.1l9.6-1.1-7.5 6.4v.1h.1l6.1-3.3 1.4-2.3h1.6l-1.1-.8 3.8-5.9-2.3 7.1h5.7l1.6 1h-7.5l-3 9.4-.4.9c-3.8-1.4-7.2-4.8-8.7-8.6-1.4-3.6-1.4-7.9.1-11.7 1.5-3.8 5-7.2 8.8-8.6 3-1.2 7-1.4 10.1-.4 3.8 1.1 7 3.7 9.1 7 2.3 3.7 2.8 8.5 1.5 12.7-1 2.9-2.6 5.6-5.1 7.5z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgFidelity;